import { render, staticRenderFns } from "./LoginShopee.vue?vue&type=template&id=3010bdfa&scoped=true&"
import script from "./LoginShopee.vue?vue&type=script&lang=js&"
export * from "./LoginShopee.vue?vue&type=script&lang=js&"
import style0 from "./LoginShopee.vue?vue&type=style&index=0&id=3010bdfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010bdfa",
  null
  
)

export default component.exports